import React from 'react';
import { observer } from 'mobx-react-lite';
import { FieldSection } from '../../components/fieldSection';
import { FieldCowerSection } from '../../components/fieldCowerSection';
import ChipsWrapper from '../chipsWrapper';
import { gameStore } from '../../store/gameStore';
import { Timer } from '../../components/timer';
import { cardsStore } from '../../store/cardsStore';
import { ShuffleCardsWrapper } from '../../components/shuffleCardWraper';

export const FieldsContainer = observer(() => {
  const { isBetsClosed } = gameStore;
  const { isShuffle } = cardsStore;

  return (
    <div className={`football-fields-container ${isBetsClosed ? 'open' : 'close'}`}>
      <div className='football-fields-container-inner'>
        <Timer />
        {isShuffle ? <ShuffleCardsWrapper /> : null}
        <FieldSection />
        <FieldCowerSection />
      </div>
      <ChipsWrapper />
    </div>
  );
});
